// extracted by mini-css-extract-plugin
export default {"wrapper":"ReportsTable_wrapper__VmECe","tableGeneral":"ReportsTable_tableGeneral__7QuKk","tableGeneralHeader":"ReportsTable_tableGeneralHeader__LQAYj"};